import { useState, useCallback } from 'react';

export interface ChatViewState {
  chatReadOnly: boolean;
  sharedConversationRecordId: number | null;
}

export interface ChatViewStateActions {
  setChatReadOnly: (readOnly: boolean) => void;
  setSharedConversationRecordId: (id: number | null) => void;
  resetChatViewState: () => void;
}

export function useChatViewState(): ChatViewState & ChatViewStateActions {
  const [chatReadOnly, setChatReadOnly] = useState(false);
  const [sharedConversationRecordId, setSharedConversationRecordId] = useState<
    number | null
  >(null);

  const resetChatViewState = useCallback(() => {
    setChatReadOnly(false);
    setSharedConversationRecordId(null);
  }, []);

  return {
    chatReadOnly,
    sharedConversationRecordId,
    setChatReadOnly,
    setSharedConversationRecordId,
    resetChatViewState,
  };
}
